// extracted by css-extract-rspack-plugin
export default {"fullWidthContainer":"_56bb3d85","headingLarge":"_99e511c2","headingLargeItalic":"_628961d8","headingMedium":"_20651ec2","headingMediumItalic":"_c8471a18"};